import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { IAskLoginModalProps } from './ask-login-modal.models';
import { useStyles } from './ask-login-modal.styles';
import { Modal, ResponsiveWidth } from '../modal';
import { Button } from '../button';

export const AskLoginModal = ({
  title, description, onNavigateToRegistration, onNavigateToLogin, ...props
}: IAskLoginModalProps): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Modal
      {...props}
      data-testid="ask-login-modal"
      responsiveWidth={ResponsiveWidth.lg}
      propsPaperStyles={classes.propsPaperStyles}
      propsContentStyles={classes.propsContentStyles}
      content={(
        <>
          <h2 className={classes.title}>
            {intl.formatMessage(
              { id: title || 'askLogin.popup.title' },
              { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
            )}
          </h2>
          <p className={classes.description}>
            {intl.formatMessage(
              { id: description },
              { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
            )}
          </p>
        </>
      )}
      footer={(
        <div className={classes.actions}>
          <Button
            variant="contained"
            onClick={onNavigateToRegistration}
            className={classes.register}
            data-testid="ask-login-register"
          >
            <FormattedMessage id="askLogin.popup.registerButton.label" />
          </Button>
          <Button
            variant="outlined"
            onClick={onNavigateToLogin}
            className={classes.login}
            data-testid="ask-login-login"
          >
            <FormattedMessage id="askLogin.popup.loginButton.label" />
          </Button>
        </div>
      )}
    />
  );
};
